const inrFormatter = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  maximumFractionDigits: 0,
});

/** Formats a rupee amount with Indian digit grouping, e.g. ₹1,20,000. */
export function formatINR(value: number): string {
  return inrFormatter.format(value);
}
